ui-bank-search-mobile-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  background: $sd-backgroundColor-white;
  padding: $sd-spacing-5 $sd-spacing-4;
  height: 250px;

  &:focus {
    outline: 2px solid $sd-borderColor-primary-DEFAULT;
  }

  &.selected {
    background: $sd-backgroundColor-primary-300;
  }

  .loading-spinner-container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  p {
    margin: 0;
  }

  .icon {
    width: 1.875rem;
    margin-right: $sd-spacing-5;
    text-align: center;

    ui-cms-image {
      display: inline-block;
      margin: 0 auto;
      width: 100%;
    }
  }

  .description {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    text-align: left;
    margin: 0 $sd-spacing-3;
    width: 70%;
    min-width: 0;

    > :not(:first-child) {
      margin-top: $sd-spacing-2\.5;
    }

    &__name {
      font-size: $sd-fontSize-base;
      font-weight: $sd-fontWeight-bold;
      color: $sd-textColor-primary-DEFAULT;
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &__phone-number {
      color: $sd-textColor-primary-DEFAULT;
    }

    &__opening-hours {
      color: $sd-textColor-black;
    }
  }

  .distance {
    color: $sd-textColor-neutral-600;
    white-space: nowrap;
  }

  &.slider-condensed {
    height: 75px;
  }
}
